import { ChangeEvent, KeyboardEvent, useCallback, useEffect, useState } from "react"
import { InputForm } from "src/components/common/form/input/InputForm"
import ModalWrapper from "src/components/common/modal/ModalWrapper"
import { useSYS1010_R01Store } from "src/containers/mes/SYS/SYS1010_R01/Store_SYS1010_R01"
import { useCommonCodeStore } from "src/store/useCommonCodeStore"

import useUiuxStore from "src/store/useUiuxStore"

import { createSYS1010_R01, deleteSYS1010_R01, getSYS1010_R01MinorCodeList, saveSYS1010_R01 } from "./Api_SYS1010_R01"
import { showSuccess } from "src/utils/toast/toastUtil"

import { defaultSYS1010_R01Dto, SYS1010_R01Dto } from "./Dto_SYS1010_R01"
import { SysCodeDto } from "src/types/base"

// 공통코드 등록/수정 모달 컴포넌트
export const SYS1010_R01Modal = () => {
	
	// zustand 스토어에서 상태 및 setter 가져오기
	const { 
		commonCodeModalProps, setCommonCodeModalProps, 
		setCommonCodeModalVisible, setMessage
	}=useUiuxStore();

	const { 
		majorSYS1010_R01List, 
		addCodeList, 
		setSelectedMajorSYS1010_R01, setMajorSYS1010_R01List, refreshMajorSYS1010_R01List, 
		updateMajorSYS1010_R01,
		searchMajorSYS1010_R01List 
	} = useSYS1010_R01Store();

	const { fetchCommonCode } = useCommonCodeStore();

	const { SYS1010_R01Filter, setSYS1010_R01Filter } = useSYS1010_R01Store();

	// 코드 입력값과 코드 정보 상태 관리
	const [codeInput,setCodeInput]=useState(commonCodeModalProps?.data?commonCodeModalProps.data.majorCd:'');
	const [codeInfo,setCodeInfo]=useState<SYS1010_R01Dto>(
		commonCodeModalProps?.data?{
			...defaultSYS1010_R01Dto,
			...commonCodeModalProps?.data
		}:defaultSYS1010_R01Dto
	);

	// 공통코드 존재시 공통코드 부분 비활성화 변수
	const [isCodeExist,setIsCodeExist]=useState(true);

	// 코드 입력값 변경 핸들러
	const handleCodeChange=(e:ChangeEvent<HTMLInputElement>)=>{
		setCodeInput(e.target.value);
	}

	// 엔터키 입력 시 코드 검색
	const handleCodeEnterKeyDown=(e:KeyboardEvent<HTMLInputElement>)=>{
		if(e.key==='Enter'){
			searchCode(codeInput);
		}
	}

	// 코드 검색 함수
	const searchCode = (code: string) => {
		const searched = majorSYS1010_R01List.find((major) => major.majorCd === code);
		if (searched) {
			setCodeInfo(searched);
		} else {
			alert('일치하는 공통코드가 없습니다.');
		}
	}

	// 신규 데이터 버튼 클릭 핸들러
	const handleNewDataClick = () => {
		setCommonCodeModalProps({ ...commonCodeModalProps, data: { ...commonCodeModalProps?.data, majorCd: '' } as SysCodeDto });
		setCodeInfo({ ...defaultSYS1010_R01Dto });
		setCodeInput('');
	}

	// 입력값 변경 핸들러
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;

		if (name === 'majorCd') {
			setCodeInfo((prev) => ({
				...prev,
				majorCd: value.toUpperCase(),
			}));
		} else {
			setCodeInfo((prev) => ({
				...prev,
				[name]: value,
			}));
		}
	};


	// 삭제 버튼 클릭 핸들러
	const handleDeleteClick = useCallback(async () => {
		const deleted = majorSYS1010_R01List.find((major) => major.majorCd === codeInfo.majorCd);
		if (deleted) {
			// 상세코드가 있는지 확인
			const minorCodeList = (await getSYS1010_R01MinorCodeList(deleted.majorCd)).data.data;
			if (minorCodeList.length > 0) {
				alert('상세코드가 있어 삭제가 불가능합니다.');
				return;
			}
			const yn = window.confirm('정말로 삭제하시겠습니까?');
			if (!yn) return;
				await deleteSYS1010_R01(deleted.majorCd);
				const deletedIndex = [...majorSYS1010_R01List].findIndex(value => value.majorCd === deleted.majorCd);
				const _majorCodeList = [...majorSYS1010_R01List].filter(value => value.majorCd !== deleted.majorCd);

				setMajorSYS1010_R01List(_majorCodeList);
			if (_majorCodeList.length === 0) {
				setSelectedMajorSYS1010_R01(undefined);
			} else {
				setSelectedMajorSYS1010_R01(_majorCodeList[deletedIndex] ?? _majorCodeList[deletedIndex - 1]);
			}

			refreshMajorSYS1010_R01List(_majorCodeList[deletedIndex] ?? _majorCodeList[deletedIndex - 1]);
			// useCommonCodeStore의 모든 공통코드 리스트 업데이트
			await fetchCommonCode();

			showSuccess('코드가 삭제되었습니다.');
			setMessage(`${codeInfo.codeNm} 코드가 삭제되었습니다.`);
			setTimeout(() => {
				setMessage("");
			}, 5000)
			setCommonCodeModalVisible(false);
		} else {
			alert("일치하는 코드가 없습니다.")
		}
	}, [codeInfo, fetchCommonCode, majorSYS1010_R01List, setMajorSYS1010_R01List, setSelectedMajorSYS1010_R01, refreshMajorSYS1010_R01List]);

	const handleSaveClick = useCallback(async () => {
    const majorCode = codeInfo.majorCd;

    if (majorCode === '') {
      alert('코드를 입력해주세요.');
      return;
    }

    const updateMode = majorSYS1010_R01List.find(value => value.majorCd === majorCode);

    let message = "";

    if (updateMode) {
      // 수정 모드
		const minorCodeList = (await getSYS1010_R01MinorCodeList(majorCode)).data.data;
		const response = await saveSYS1010_R01(codeInfo, minorCodeList);
		if (response.data.successFlag) {
			await useSYS1010_R01Store.getState().fetchSYS1010_R01();
			// useCommonCodeStore의 모든 공통코드 리스트 업데이트
			await fetchCommonCode();
			message = `${codeInfo.codeNm} 코드가 수정되었습니다.`;
			searchMajorSYS1010_R01List(SYS1010_R01Filter.codeInput);
		} else {
			alert(response.data.message);
		}
		
    } else {
		// 신규 등록 모드
		const response = await createSYS1010_R01(codeInfo)
		if (response.data.successFlag) {
			addCodeList(response.data.data);
			// useCommonCodeStore의 모든 공통코드 리스트 업데이트
			await fetchCommonCode();
			message = `${codeInfo.codeNm} 코드 등록에 성공하였습니다.`;
			refreshMajorSYS1010_R01List(response.data.data);
		} else {
			alert(response.data.message);
		}
    }

	showSuccess(message);
    setMessage(message);
    setTimeout(() => {
      setMessage("");
    }, 5000)
    setCommonCodeModalVisible(false);
  }, [codeInfo, fetchCommonCode, majorSYS1010_R01List, addCodeList, refreshMajorSYS1010_R01List, searchMajorSYS1010_R01List, SYS1010_R01Filter]);

	// 공통코드 존재시 공통코드 부분 비활성화
	useEffect(() => {
		if (
			commonCodeModalProps?.data?.majorCd && 
			commonCodeModalProps?.data?.majorCd !== ''
		) {
			setIsCodeExist(false);
		} else {
			setIsCodeExist(true);
		}
	}, [commonCodeModalProps]);

	// 렌더링
	return (
		<ModalWrapper 
			overlay={true}
			onOverlayClick={() => setCommonCodeModalVisible(false)}
			onEscKeyDown={() => setCommonCodeModalVisible(false)}
			size="sm"
			width={700}
		>
			{/* 모달 헤더 */}
			<div className="w-full h-[36px] flex items-center px-[24px] bg-blue-dark">
				<p className="font-bold text-white">
					공통코드 등록
				</p>
			</div>
			{/* 모달 본문 */}
			<div className="w-full h-[80%] flex flex-col px-[24px] py-[12px] gap-[16px]">
				{/* 코드 검색 영역 */}
				<div className="flex items-center gap-[8px] px-[12px] py-[4px] rounded-[6px]" >
					<p className="h-[24px] flex items-center gap-[24px]">공통코드</p>
					<input className="bg-white px-[6px] w-[120px] h-[24px] rounded-[6px] border"
						value={codeInput}
						onChange={handleCodeChange}
						onKeyDown={handleCodeEnterKeyDown} />
					<input className="bg-gray-disable px-[6px] w-[240px] h-[24px] rounded-[6px]" disabled={true} />
					<div className="flex gap-[8px] ml-auto">
						<button className={`text-white rounded-[4px] bg-blue-dark px-[16px] font-semibold`}
							onClick={() => searchCode(codeInput)}>
							조회
						</button>
						<button className={`text-white rounded-[4px] bg-blue-dark px-[16px] font-semibold`}
							onClick={handleNewDataClick}>
							신규
						</button>
					</div>
				</div>
				{/* 코드 정보 입력 영역 */}
				<div className="w-full flex flex-wrap gap-[6px]">
					
					<InputForm title="공통코드" value={codeInfo.majorCd} editable={isCodeExist} name="majorCd" onChange={handleChange} />
					<InputForm title="코드명" value={codeInfo?.codeNm || ''} editable={true} name="codeNm" onChange={handleChange} />
					
					<InputForm title="상세코드" value={codeInfo?.minorCd} editable={false} />
					<InputForm title="시스템여부" value={codeInfo?.sysFlg || ''} editable={false} />
					<InputForm title="출력순서" value={codeInfo?.dispSeq || 0} editable={false} />
					
					<InputForm title="참조1 용도" value={codeInfo?.ref01 || ''} editable={true} name="ref01" onChange={handleChange} />
					<InputForm title="참조2 용도" value={codeInfo?.ref02 || ''} editable={true} name="ref02" onChange={handleChange} />
					<InputForm title="참조3 용도" value={codeInfo?.ref03 || ''} editable={true} name="ref03" onChange={handleChange} />
					<InputForm title="참조4 용도" value={codeInfo?.ref04 || ''} editable={true} name="ref04" onChange={handleChange} />
					<InputForm title="참조5 용도" value={codeInfo?.ref05 || ''} editable={true} name="ref05" onChange={handleChange} />
					<InputForm title="참조6 용도" value={codeInfo?.ref06 || ''} editable={true} name="ref06" onChange={handleChange} />
					<InputForm title="참조7 용도" value={codeInfo?.ref07 || ''} editable={true} name="ref07" onChange={handleChange} />
					<InputForm title="참조8 용도" value={codeInfo?.ref08 || ''} editable={true} name="ref08" onChange={handleChange} />
					<InputForm title="참조9 용도" value={codeInfo?.ref09 || ''} editable={true} name="ref09" onChange={handleChange} />
					<InputForm title="참조10 용도" value={codeInfo?.ref10 || ''} editable={true} name="ref10" onChange={handleChange} />
					
					<InputForm title="비고" value={codeInfo?.remark || ''} editable={true} name="remark" onChange={handleChange} />
				</div>
			</div>
			{/* 모달 푸터 */}
			<div className="w-full h-[10%] flex items-center justify-end px-[24px] gap-[8px] p-[12px]">
				<button className={`text-white rounded-[4px] bg-blue-dark px-[16px] font-semibold`} onClick={handleSaveClick} >
					저장
				</button>
				<button className={`text-white rounded-[4px] bg-blue-dark px-[16px] font-semibold`} onClick={handleDeleteClick}>
					삭제
				</button>
				<button className={`text-white rounded-[4px] bg-blue-dark px-[16px] font-semibold`} onClick={() => setCommonCodeModalVisible(false)} >
					취소
				</button>
			</div>
		</ModalWrapper>
	)
}